import { RouteObject } from 'react-router';

import { anonymousLoader, protectedLoader } from './lib/auth-loader';

import { route as routeCommonLayout } from './layout/common-layout';
import { route as routeAppLayout } from './layout/app-layout';

import { route as routeTournamentList } from './pages/tournament-list';
import { route as routeControlPanel } from './pages/control-panel';
import { route as routeProfile } from './pages/profile';
import { route as routeClubSelector } from './pages/club-selector';
import { route as routeLogin } from './pages/login';
import { route as routeSignup } from './pages/signup';
import { route as routeCourtList } from './pages/court-list';
import { route as routeCourt } from './pages/court/layout';
import { route as routeUserList } from './pages/user-list';
import { route as routeTournament } from './pages/tournament/layout';
import { route as routeRegister } from './pages/public-tournament/layout';
import { route as routeConfirmRegister } from './pages/confirm-register';
import { route as routeRegisterSuccess } from './pages/register-success';
import { ErrorBoundary } from './pages/error-boundy';
import { route as routeEditProduct } from './pages/product/edit-product';
import { route as routeEditCategory } from './pages/product/edit-category';
import { route as routeConfigLayout } from './pages/config/layout';
import { route as routeSales } from './pages/product/sales/route';
import { route as routeProductLayout } from './pages/product/layout';
import { route as routePlayersLayout } from './pages/players/route';
import { route as routeOpenMatchesList } from './pages/open-matches/open-matches-list';
import { route as routeCashierLayout } from './layout/cashier-layout';
import { route as routeCashierPage } from './pages/cashier/cashier-page';

export const routes: RouteObject[] = [
  {
    ...routeCommonLayout,
    errorElement: <ErrorBoundary />,
    children: [
      routeRegister,
      routeConfirmRegister,
      routeRegisterSuccess,
      {
        loader: anonymousLoader,
        children: [routeLogin, routeSignup],
      },
      {
        loader: protectedLoader,
        children: [
          routeClubSelector,
          {
            ...routeAppLayout,
            children: [
              routeControlPanel,
              routeCourtList,
              routeCourt,
              routeTournamentList,
              routeTournament,
              routeUserList,
              routeProfile,

              // Product routes
              routeProductLayout,
              routeEditProduct,
              routeEditCategory,

              routeConfigLayout,

              routeSales,

              routePlayersLayout,

              routeOpenMatchesList,
            ],
          },
          // Cashier mode (separate layout, no sidebar)
          {
            ...routeCashierLayout,
            children: [routeCashierPage],
          },
        ],
      },
    ],
  },
];
